import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import React from 'react'
import * as yup from 'yup'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import rem from '@/utils/rem'
import Button from '@/components/Button/index'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure.svg';

const validationSchema = yup.object({
referenceNumber: yup
	.string('Enter your Reference Number')
	.min(8, 'Reference Number should be minimum of 8 characters length')
	.max(32, 'Reference Number should be of 32 characters length')
	.required('Reference Number is required'),
})

export default function UpdatereferenceNumberModal({ visible, close, submit, id }) {
	const { t } = useTranslation()
	const formik = useFormik({
		validationSchema: validationSchema,
		validateOnMount: true,
		initialValues: {
			referenceNumber: '',
		},
	})

	const ErrorMessage = ({ name }) =>
		formik.errors[name] && formik.touched[name] ? (
		<div className="error-message">{formik.errors[name]}</div>
		) : null

	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconConfigure />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Update my unique Reference ID
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="eclip-receipient__input">
							<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
								Current Reference ID
							</span>
							<input
								type="text"
								name="referenceNumber"
								value={id}
								placeholder="Enter ID"
								disabled
								style={{marginBottom: 16}}
							/>
							<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span" style={{marginTop: rem(16)}}>
								New Reference ID
							</span>
							<input
								type="text"
								name="referenceNumber"
								value={formik.values.referenceNumber}
								onChange={formik.handleChange}
								placeholder="Enter ID"
							/>
							<div className="eclip-create__input-description">
								{t('referenceNumberDescription')}
							</div>
							<ErrorMessage name="referenceNumber" />
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Update"
							disabled={!formik.isValid}
							submit={() => {
								submit(formik.values.referenceNumber)
							}}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
